/**
 * LISTADO DE ENDPOINTS API GESTIÓN DOCUMENTOS https://apigestiondocumentosdev.azurewebsites.net
 */
const URL_API_GESTION_DOCUMENTOS = {
    /**
     * AgregarDocumento ENDPOINT de API GESTIÓN DOCUMENTOS
     * Método: POST
     * Descripción: Permite agregar un documento (con soporte para subida en chunks).
     */
    AGREGAR_DOCUMENTO: `${import.meta.env.VITE_API_GESTION_DOCUMENTOS}/Api/Documentos/AgregarDocumento`,

    /**
     * EditarDocumento ENDPOINT de API GESTIÓN DOCUMENTOS
     * Método: PUT
     * Descripción: Permite editar la información de un documento existente.
     */
    EDITAR_DOCUMENTO: `${import.meta.env.VITE_API_GESTION_DOCUMENTOS}/Api/Documentos/EditarDocumento`,

    /**
     * EliminarDocumento ENDPOINT de API GESTIÓN DOCUMENTOS
     * Método: PUT
     * Descripción: Permite eliminar lógicamente un documento existente.
     */
    ELIMINAR_DOCUMENTO: `${import.meta.env.VITE_API_GESTION_DOCUMENTOS}/Api/Documentos/EliminarDocumento`,

    /**
     * DesactivarDocumentosNoCompletados ENDPOINT de API GESTIÓN DOCUMENTOS
     * Método: PUT
     * Descripción: Desactiva documentos relacionados a un trámite que no fueron completados.
     */
    DESACTIVAR_DOCUMENTOS_NO_COMPLETADOS: `${import.meta.env.VITE_API_GESTION_DOCUMENTOS}/Api/Documentos/DesactivarDocumentosNoCompletados`,
    /**
     * OBTENER_URL_CON_SAS_TOKEN ENDPOINT de API GESTIÓN DOCUMENTOS
     * Método: POST
     * Descripción: 
     * - Recibe como parámetro la URL de origen del documento.
     * - Retorna la URL con SAS Token que permite el acceso seguro al documento.
     * - Actualiza el CONTENT-DISPOSITION del blob en Azure Storage para que el archivo se pueda visualizar correctamente.
     */
    OBTENER_URL_CON_SAS_TOKEN: `${import.meta.env.VITE_API_GESTION_DOCUMENTOS}/Api/Documentos/v2/ChangeAccessBlob`,
    /**
     * VizualizacionDescargaDocumento ENDPOINT de API GESTIÓN DOCUMENTOS
     * Método: GET
     * Descripción: Registra las actividades de un documento tanto visualizacion como descarga.
     */
    VISUALIZACION_DESCARGA_DOCUMENTO: `${import.meta.env.VITE_API_GESTION_DOCUMENTOS}/Api/Documentos/VizualizacionDescargaDocumento`,
};

export default URL_API_GESTION_DOCUMENTOS;